import { render, staticRenderFns } from "./EmptyCell.vue?vue&type=template&id=2e213d1f&scoped=true&"
import script from "./EmptyCell.vue?vue&type=script&lang=ts&"
export * from "./EmptyCell.vue?vue&type=script&lang=ts&"
import style0 from "./EmptyCell.vue?vue&type=style&index=0&id=2e213d1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e213d1f",
  null
  
)

export default component.exports